import React, { useRef, useState } from 'react';

export const VideoBlock = (props: VideoBlockProps) => {
    const [isPlaying, setIsPlaying] = useState(true);
    const videoRef = useRef<HTMLVideoElement>();

    const toggleVideo = () => {
        if (isPlaying) {
            videoRef.current?.pause();
            setIsPlaying(false);
        } else {
            videoRef.current?.play();
            setIsPlaying(true);
        }
    }

    return (
        <div className="full-width-block full-width-block--hero">
            <div className="full-width-block__image-heading-container">
                <div className="videoblock__container" onClick={toggleVideo}>
                    <video ref={videoRef} autoPlay loop muted playsInline width="100%" poster={props.posterImage} aria-hidden="true">
                        <source src={props.videoUrl} type="video/mp4" />
                    </video>
                    <div className="videoblock__overlay-container">
                        <div className={props.textAlignment == "center" ? "videoblock__overlay videoblock__overlay--centered" : "videoblock__overlay"}>
                            <div className="videoblock__text-container">
                                <h1 id="h1id">{props.title}</h1>
                                <h2 className="videoblock__sub-heading">{props.ingress}</h2>
                                <a href={props.link}>{props.linkText}</a>
                            </div>
                            {isPlaying ?
                                <button className="videoblock__button" aria-label="Pausa videon" type="button" dangerouslySetInnerHTML={{ __html: props.pauseIcon }}>
                                </button> :
                                <button className="videoblock__button" aria-label="Spela videon" type="button" dangerouslySetInnerHTML={{ __html: props.playIcon }}>
                                </button>
                            }
                        </div>
                    </div>
                    <div className="videoblock__overlay-container videoblock__overlay-container--mobile">
                        <div className={props.textAlignment == "center" ? "videoblock__overlay videoblock__overlay--centered" : "videoblock__overlay"}>
                            <div className="videoblock__text-container">
                                <h1>{props.title}</h1>
                                <div className="videoblock__overlay-text">
                                    <h2 className="videoblock__sub-heading">{props.ingress}</h2>
                                    {isPlaying ?
                                        <button className="videoblock__button" aria-label="Pausa videon" type="button" onClick={toggleVideo} dangerouslySetInnerHTML={{ __html: props.pauseIcon }}>
                                        </button> :
                                        <button className="videoblock__button" aria-label="Spela videon" type="button" onClick={toggleVideo} dangerouslySetInnerHTML={{ __html: props.playIcon }}>
                                        </button>
                                    }
                                </div>
                            </div>
                            <a href={props.link}>{props.linkText}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}